var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-consults.b700d984.png","uri@2x": __webpack_public_path__ + "icon-consults.aefa7cc2.png","uri@3x": __webpack_public_path__ + "icon-consults.d41606aa.png",
    width: 20,
    height: 20
});